/**
 * Created by hmeerlo on 09/09/15.
 */
import React from 'react';// eslint-disable-line no-unused-vars
import reactMixin from 'react-mixin';
//import baseComponent from '../../decorators/baseComponent';

@reactMixin.decorate(require('react-intl').IntlMixin)
class BaseReactComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  getChildContext() {
    let baseMessageKey = (this.props.baseMessageKey || this.context.baseMessageKey);
    let componentKey = baseMessageKey ? baseMessageKey + (this.props.componentName ? '.' + this.props.componentName : '') : (this.props.componentName ? this.props.componentName : '');

    return {
      baseMessageKey: componentKey
    };
  }

  getMessage(path) {
    let baseMessageKey = (this.props.baseMessageKey || this.context.baseMessageKey);
    let componentKey = baseMessageKey ? baseMessageKey + (this.props.componentName ? '.' + this.props.componentName : '') : (this.props.componentName ? this.props.componentName : '');

    return this.getIntlMessage(componentKey ? componentKey + '.' + path : path);
  }

  shouldComponentUpdate(newprops, newstate) {
    for (let key in newprops) {
      if (newprops[key] !== this.props[key]) {
        return true;
      }
    }
    for (let key in this.props) {
      if (newprops[key] !== this.props[key]) {
        return true;
      }
    }
    for (let key in newstate) {
      if (newstate[key] !== this.state[key]) {
        return true;
      }
    }
    for (let key in this.state) {
      if (newstate[key] !== this.state[key]) {
        return true;
      }
    }
    return false;
  }
}

const types = BaseReactComponent.childContextTypes;

BaseReactComponent.childContextTypes = {
  ...types,
  baseMessageKey: React.PropTypes.string
};

BaseReactComponent.contextTypes = {
  ...types,
  baseMessageKey: React.PropTypes.string
};

BaseReactComponent.propTypes = {
  componentName: React.PropTypes.string
};

export default BaseReactComponent;



// WEBPACK FOOTER //
// /src/components/Util/BaseReactComponent.js